document.getElementById("facturaForm").addEventListener("submit", function(event) {
    event.preventDefault();

    // Limpiar errores previos
    clearErrors();

    var valid = true;
    var formData = new FormData(this);
    var archivos = document.getElementById("documentos").files;
    var archivosBase64 = [];

    // Validación del Número de Pedido Shopify
    var numeroPedido = document.getElementById("numero_pedido").value;
    if (numeroPedido === "") {
      valid = false;
      document.getElementById("errorNumeroPedido").innerText = "El número de pedido es obligatorio.";
    }

    // Validación del nombre o razón social
    var nombre = document.getElementById("nombre").value;
    if (nombre === "") {
      valid = false;
      document.getElementById("errorNombre").innerText = "El nombre es obligatorio.";
    }

    // Validación del RFC
    var rfc = document.getElementById("rfc").value;
    if (rfc === "") {
      valid = false;
      document.getElementById("errorRFC").innerText = "El RFC es obligatorio.";
    }

    // Validación de la dirección
    var direccion = document.getElementById("direccion").value;
    if (direccion === "") {
      valid = false;
      document.getElementById("errorDireccion").innerText = "La dirección es obligatoria.";
    }

    // Validación del régimen fiscal
    var regimen = document.getElementById("regimen").value;
    if (regimen === "") {
      valid = false;
      document.getElementById("errorRegimen").innerText = "El régimen fiscal es obligatorio.";
    }

    // Validación del uso de CFDI
    var usoCfdi = document.getElementById("uso_cfdi").value;
    if (usoCfdi === "") {
      valid = false;
      document.getElementById("errorUsoCFDI").innerText = "El uso de CFDI es obligatorio.";
    }

    // Validación del correo electrónico
    var email = document.getElementById("email").value;
    if (email === "" || !validateEmail(email)) {
      valid = false;
      document.getElementById("errorEmail").innerText = "Por favor ingresa un correo electrónico válido.";
    }

    // Validación de la forma de pago
    var formaPago = document.getElementById("forma_pago").value;
    if (formaPago === "") {
      valid = false;
      document.getElementById("errorFormaPago").innerText = "La forma de pago es obligatoria.";
    }

    // Validación de los archivos (si se requieren)
    if (archivos.length === 0) {
      valid = false;
      document.getElementById("errorDocumentos").innerText = "Debes subir al menos un documento.";
    }

    if (valid) {
      var archivosProcesados = 0;
      for (let i = 0; i < archivos.length; i++) {
        let reader = new FileReader();
        reader.readAsDataURL(archivos[i]);
        reader.onload = function () {
          archivosBase64.push({
            nombre: archivos[i].name,
            tipo: archivos[i].type,
            contenido: reader.result.split(",")[1] // Separamos el Base64
          });

          archivosProcesados++;
          if (archivosProcesados === archivos.length) {
            enviarFormulario(formData, archivosBase64);
          }
        };
      }
    }
  });

  function enviarFormulario(formData, archivosBase64) {
    // Función para obtener el código y el texto del select
    function getSelectValue(selectId) {
      var select = document.getElementById(selectId);
      var selectedOption = select.options[select.selectedIndex];
      return selectedOption.value + " - " + selectedOption.text;
    }

    // Modificar los valores en formData para incluir código + texto
    formData.set("regimen", getSelectValue("regimen"));
    formData.set("uso_cfdi", getSelectValue("uso_cfdi"));
    formData.set("forma_pago", getSelectValue("forma_pago"));

    // Agregar archivos en Base64
    formData.append("archivos", JSON.stringify(archivosBase64));

    // Agregar el Número de Pedido de Shopify
    formData.set("numero_pedido", document.getElementById("numero_pedido").value);

    fetch("https://script.google.com/macros/s/AKfycbwYwQeHgv11VjIbGHhqg0OClgiWURWRTM2lntKztRLjwWmZY5y9lyMruOYTV0DE6Lrq/exec", {
      method: "POST",
      body: formData
    })
    .then(response => response.text())
    .then(data => {
      alert("Factura solicitada correctamente.");
      document.getElementById("facturaForm").reset();
    })
    .catch(error => console.error("Error:", error));
  }

  // Función para validar el correo electrónico
  function validateEmail(email) {
    var re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(email);
  }

  // Limpiar los errores previos
  function clearErrors() {
    var errors = document.querySelectorAll(".error");
    errors.forEach(function(error) {
      error.innerText = "";
    });
  }

